import React from "react";
import constants from "../assets/js/constants";

function CircleMedia({
  description,
  value,
  backgroundColor = constants.COLORS.PRIMARY,
}) {
  return (
    <div className="circle-media" style={{ backgroundColor }}>
      <span className="circle-media__value">{value}</span>
      <span className="circle-media__description">{description}</span>
    </div>
  );
}

export default CircleMedia;
